import React, { useMemo } from 'react'
import { Button, withStyles } from '@material-ui/core'
import { useHistory } from 'react-router'
import { useFeatureEnabled } from 'core/feature/hooks'
import { navigateWithStack } from 'core/navigation/navigationStack'
import useProcessMemberApprovals from './useProcessMemberApprovals'

const ReviewButton = withStyles({
  root: {
    background: '#F4BF2C',
    color: '#333333',
    fontWeight: 400,
    minWidth: 'auto',
    height: 'auto',
    fontSize: '13px',
    lineHeight: '20px',
    padding: '5px 15px',
    borderRadius: '4px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F4BF2C',
      boxShadow: 'none',
    },
  },
  label: {
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: 400,
  },
})(Button)

const ViewButton = withStyles({
  root: {
    color: '#3776CF',
    textTransform: 'none',
    minWidth: 'auto',
    padding: 0,
    fontWeight: 400,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'none',
    },
  },
})(Button)

const useGroupMemberActionCell = (group: { id: number; name?: string }, refresh?: () => void) => {
  const newApproveUIEnabled = useFeatureEnabled('NewGroupApplicationPage')
  const history = useHistory()
  const { processApprovals: handleShowApprovals } = useProcessMemberApprovals(refresh)
  const backLabel = group.name ? `Return to ${group.name}` : 'Return to Group'

  return useMemo(() => {
    const ActionCell = ({ row }: any) => {
      const isApplicant = row.original.status?.code === 'applicant'
      const personId = row.original.person?.id
      const membershipId = row.original.id

      const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        if (isApplicant) {
          if (newApproveUIEnabled) {
            history.push(`/groups/${group.id}/applications/${personId}`)
          } else {
            handleShowApprovals(group, row.values.status, membershipId)
          }
          return
        }
        navigateWithStack(history, `/champion/${personId}`, backLabel)
      }

      return isApplicant ? (
        <ReviewButton variant="contained" onClick={handleClick}>
          Review
        </ReviewButton>
      ) : (
        <ViewButton onClick={handleClick}>View</ViewButton>
      )
    }

    return ActionCell
  }, [backLabel, group, handleShowApprovals, history, newApproveUIEnabled])
}

export default useGroupMemberActionCell
